//
// LegendItemDisplay.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../core/FillOutlineDisplay";

var LegendItemDisplay = createModule("gtl::LegendItemDisplay", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::FillOutlineDisplay"], EventDispatcher, [
    ,
    ,
    ,
    ,
    ,
    {
        _create_v: [4],
        _create_s: [4,7],
        getValueFromString: [1,7,1],
        createSTANDARD: [1],
    },
    ,
    ["_create"]
]);
export default LegendItemDisplay;
